import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Typography, Button } from '@mui/material';
import { IconMenu2 } from '@tabler/icons';
import { useNavigate } from 'react-router-dom';
import { useSelector,useDispatch } from 'react-redux'
import { USER_LOGIN } from '../../store/actions';
import axios from "../../components/axios";
import { GoogleOAuthProvider, GoogleLogin, googleLogout } from '@react-oauth/google';
import { useEffect } from "react";
import { datadogLogs } from '@datadog/browser-logs';


const Header = ({ handleLeftDrawerToggle }) => {
    const client_id = process.env.REACT_APP_CLIENT_ID;
    const theme = useTheme();
    const navigate = useNavigate();
    var user_login = useSelector(state => state.customization.login)
    const dispatch = useDispatch();

    const styleButton = {
        width: "120px",
        fontSize: "16px",
        fontFamily: '"Roboto", "sans-serif"',
    };

    const responseGoogle = (response) => {
        dispatch({ type: USER_LOGIN, login: true });
        localStorage.setItem("gapi.tokenId",response.credential);
        getPermission();
    }

    const handleLogout = async () => {
        googleLogout();
        axios.post("/peloton/v1/users/logout", null, { withCredentials: true});
        alert("Logout success!");
        localStorage.removeItem("gapi.tokenId");
        localStorage.removeItem("qbarn.user");
        dispatch({ type: USER_LOGIN, login: false });
        navigate("/");
    }

    useEffect(() => {
        const checkUserToken = async () => {
            try {
                const response = await axios.post("/peloton/v1/users/auth-token", null, { withCredentials: true});
                if (response.data.message === "success"){
                    dispatch({ type: USER_LOGIN, login: true });
                }
            } catch (error) {
                handleLogout();
                if (error.response.status !== null){
                    console.log('error.response.status: ', error.response.status);
                    console.log('error.response.message: ', error.response.data.message);
                }else{
                    console.log(error);
                }
            }
        };
        if (localStorage.getItem( "qbarn.user" ) !== null) {
            checkUserToken();
        }else{
            dispatch({ type: USER_LOGIN, login: false });
            navigate("/");
        }
    });

    function getPermission() {
        let idToken = localStorage.getItem( "gapi.tokenId" )
        axios.post("/peloton/v1/users/role-permission",null,{
            headers: {
              'Authorization': 'Bearer '+idToken
            },
            withCredentials: true
        })
        .then(response => {
            if (response.data.message === "success") {
                if (localStorage.getItem( "qbarn.user" ) === null) {
                    localStorage.setItem("qbarn.user", JSON.stringify(response.data.user_info))
                    if (process.env.REACT_APP_ENV.trim() === "dev" || process.env.REACT_APP_ENV.trim() === "stage"){
                        datadogLogs.logger.info('qbarn-frontend', { name: 'Login', id: response.data.user_info.uuid })
                    }
                    dispatch({ type: USER_LOGIN, login: true });
                    navigate("/");
                }else{
                    dispatch({ type: USER_LOGIN, login: false });
                }
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
            if (!err.response){
                alert(err);
            }else{
                if (err.response.status === 401){
                  navigate("/");
                  alert(err.response.data.message);
                }else{
                    console.log('error.response.status: ', err.response.status)
                    console.log('error.response.status: ', err.response.data.message)
                    alert(err.response.data.message)
                }
            }
        })
    }

    return (
        <>
        <Box
            sx={{
                width: 228,
                display: 'flex',
                [theme.breakpoints.down('md')]: {
                    width: 'auto'
                }}
            }>
            <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                <Typography variant="h4" component="div" sx={{ flexGrow: 1,color: "#406599", fontFamily: '"Roboto", "sans-serif"' }}>
                QBarn
                </Typography>
            </Box>
            <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                <Avatar
                    variant="rounded"
                    sx={{
                        ...theme.typography.commonAvatar,
                        ...theme.typography.mediumAvatar,
                        transition: 'all .2s ease-in-out',
                        background: "#60ABD2",
                        color: "#406599",
                        '&:hover': {
                            background: "#406599",
                            color: "#60ABD2"
                        }
                    }}
                    onClick={handleLeftDrawerToggle}
                >
                <IconMenu2 stroke={1.5} size="1.3rem" />
                </Avatar>
            </ButtonBase>
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Box>
            {!user_login && (
                <GoogleOAuthProvider clientId={client_id}>
                    <GoogleLogin
                        onSuccess={responseGoogle}
                        onError={responseGoogle}
                        text='Login'
                        useOneTap
                  />
              </GoogleOAuthProvider>
            )}
            {user_login && (
                <Button style={styleButton} onClick={handleLogout}>Logout</Button>
            )}
        </Box>
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
